
import { computed, defineComponent } from "vue";
import { getModule } from "vuex-module-decorators";
import { ViewportStoreModule } from "@stores/viewport.store";
const ViewportStore = getModule(ViewportStoreModule);

export default defineComponent({
  props: {
    headline: { default: "", type: String },
    variants: {
      default: "primary",
      type: String,
      validator: (value: string) => ["primary", "secondary", "transparent"].includes(value),
    },
  },

  setup() {
    const mobileMode = computed(() => ViewportStore.smartphone);

    return { mobileMode };
  },
});
